// API configuration for different environments

const getApiBaseUrl = () => {
  const isDevelopment = import.meta.env.DEV;

  if (isDevelopment) {
    return import.meta.env.VITE_API_URL ?? 'http://localhost:8000';
  } else {
    // Production environment - use env override or default to production URL
    // This allows local preview testing with local backend
    return import.meta.env.VITE_API_URL ?? 'https://myoneqr.com/backend';
  }
};

export const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  UPLOAD_ENDPOINT: '/upload/profile-image',
  TIMEOUT: 30000, // 30 seconds timeout for uploads
};

export default API_CONFIG;

